<script>
import { Carousel, Slide } from "vue-carousel";
import { BaseButton, BaseIcon, PopupRight } from "@/components";
import { mapActions, mapGetters } from "vuex";
import mixins from "../../mixins/";

export default {
  name: "PackageSlider",
  mixins: [mixins],
  props: {
    packages: Array,
    isDisplay: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Carousel,
    Slide,
    BaseButton,
    BaseIcon,
    PopupRight,
  },
  data() {
    return {
      isDisplayed: undefined,
      price: [],
      overallLimit: null,
      isPopupVisible: false,
      selectedMoreElem: {
        name: null,
        imageUrl: null,
        applicationId: null,
      },
      packagesList: this.packages,
      isToggled: false,
      item: null,
    };
  },
  created() {
    this.isDisplayed = this.isDisplay;
  },
  methods: {
    ...mapActions([
      "createPackage",
      "monthlyGetOverallLimit",
      "researchCreate",
    ]),
    changeSliderStatus() {
      this.isDisplayed = !this.isDisplayed;
    },
    getCustomerNumber() {
      return this.customer.customerNo
        ? this.customer.customerNo
        : this.$route.query.c;
    },
    purchaseResearch(val) {
      const recoArgs = {
        IsRecommendedPackage: true,
        RecommendedPackageId: val,
      };
      this.researchCreate(recoArgs).then((res) => {
        if (res.error) {
          this.$toast.error(res.message);
        } else {
          this.$toast.success(
            "Paketiniz en kısa sürede tanımlanacaktır. Kullanıcı adı ve şifre bilgisi gerektiren paketlerde bu bilgiler e-posta ile gönderilmektedir. Lütfen e-posta adresinizde spam klasörünü kontrol ediniz."
          );
          this.$router.push({
            name: "CustomerDetail",
            params: {
              customerId: this.$route.query.c,
              customerNumber: this.getCustomerNumber(),
            },
            query: { c: this.$route.query.c },
          });
        }
      });
    },
    purchase(val, item) {
      const args = {
        IsRecommendationPackage: true,
        PurchaseId: val,
      };
      if (item.isResearch) {
        this.$modal.show(String(val));
      } else {
        this.createPackage(args).then((res) => {
          if (res.error) {
            this.$toast.error(res.message);
          } else {
            this.$router.push({
              name: "Checkout",
              params: {
                packageNumber: res.purchaseId,
                isUpgradedPurchase: res.isUpgradedPurchase,
                customerNumber: this.customer.customerNo
                  ? this.customer.customerNo
                  : this.$route.query.c,
              },
              query: { c: this.$route.query.c },
            });
          }
        });
      }
    },
    getOverallLimitOnLoad() {
      this.monthlyGetOverallLimit().then((response) => {
        if (response.status === 200) {
          this.overallLimit = this.formatPrice(response.data.overallLimit);
        }
      });
    },
    setDefaultValues() {
      this.isPopupVisible = false;
    },
    closeModal(modalId) {
      this.$modal.hide(String(modalId));
    },
    toggleThisAccordion(index) {
      this.packagesList[index].isOpened = !this.packagesList[index].isOpened;
    },
    pageChanged() {
      this.packagesList?.forEach((elem) => {
        const Matriks = this.Products.name.Matriks == elem.application?.applicationId;
        const MatriksIQ = this.Products.name.MatriksIQ == elem.application?.applicationId;
        const isDesktop = this.Products.type.Desktop == elem.platform?.platformId;
        const isMobile = this.Products.type.Mobile == elem.platform?.platformId;
        const isMobileAndDesktop = this.Products.type.DesktopAndMobile == elem.platform?.platformId;
        const OSM_PRODUCT = "Osmanlı Pro";
        const getOsmPro = elem.research.length ? elem.research.filter((i) => i.researchFeature?.name == OSM_PRODUCT) : false;
        const isOsmPro =  getOsmPro.length;
        if(
          (MatriksIQ && isDesktop && isOsmPro) || 
          (MatriksIQ && isMobile && isOsmPro) || 
          (MatriksIQ && isMobileAndDesktop && isOsmPro) ||
          (Matriks && isMobile && isOsmPro) || 
          (Matriks && isMobileAndDesktop && isOsmPro) 
        ){
          elem.isOpened = true
        } else {
          elem.isOpened = false;
        }
      });
    },
    calculateTotal(marketPrice, perspectivePrice) {
      return marketPrice + perspectivePrice;
    },
    vueCarouselAttributes() {
      setTimeout(() => {
        const elements = document.querySelectorAll(
          ".VueCarousel-dot-container"
        )[0]?.children;
        if (elements) {
          const elementsArray = Array.from(elements);
          elementsArray?.forEach((element) => {
            element.setAttribute("aria-label", "");
            element.setAttribute("title", "");
          });
        }
      }, 1000);
    },
  },
  computed: {
    ...mapGetters(["customer", "getUserInfo", "allPackages"]),
    getAllCanceledPackageStatus() {
      return this.allPackages.data.filter((o) => o.packageStatus.id == 8);
    },
    checkHasPrices() {
      return this.packages;
    },
  },
  mounted() {
    this.getOverallLimitOnLoad();
    this.vueCarouselAttributes();
  },
  watch: {
    isDisplayed: {
      handler() {
        this.pageChanged();
      },
    },
  },
  updated() {
    this.vueCarouselAttributes();
  },
};
</script>

<template>
  <div class="package-slider">
    <div class="package-slider__head">
      <label class="switch">
        <input
          type="checkbox"
          @click="changeSliderStatus"
          :checked="isDisplayed && 'checked'"
          id="switch-input"
        />
        <span id="switch-slider" class="switch-slider"></span>
      </label>
      <h4 class="package-slider__title">En Çok Kullanılan Paketleri Göster</h4>
    </div>
    <carousel
      :perPageCustom="[
        [320, 1],
        [930, 2],
      ]"
      :mouseDrag="true"
      paginationActiveColor="#2c2c30"
      paginationColor="#bebec3"
      :scrollPerPage="true"
      @page-change="pageChanged"
      v-if="isDisplayed"
    >
      <slide :key="pg.id" v-for="(pg, index) in packagesList" :index="index">
        <div class="package-item">
          <div class="package-item__image">
            <img
              v-if="pg && pg.imageUrl"
              alt="product image"
              :src="pg.imageUrl"
              class="image"
            />
            <base-icon v-else name="no-image" class="image" />
          </div>
          <div class="package-item__info">
            <div class="title">
              <h6 v-if="pg.application != null">
                {{ pg.application.name }}
                <span
                  class="lighter"
                  v-if="
                    pg.productName == 'Matriks' ||
                    pg.productName == 'Matriks IQ' ||
                    pg.productName == 'İdeal' ||
                    pg.productName == 'Foreks'
                  "
                >
                  {{ pg.platform.name }}
                </span>
                <span v-else>
                  {{ pg.productName }}
                </span>
              </h6>
              <h6 v-else>
                {{ pg.productName }}
                <span class="lighter"> </span>
              </h6>
            </div>
            <div class="description" v-if="pg && pg.type">
              <span>{{ pg.type }}</span>
            </div>
            <div class="description">
              <span v-if="pg.vendorFeature && pg.vendorFeature.name">{{
                pg.vendorFeature.name
              }}</span>
              <span v-if="pg.marketFeature && pg.marketFeature.name">
                {{ pg.marketFeature.name }}</span
              >
              <span v-if="pg.perspectiveFeature && pg.perspectiveFeature.name">
                {{ pg.marketFeature.name }}
                {{ pg.perspectiveFeature.name }}</span
              >
            </div>
            <div class="description">
              <div>BES / Yatırım Fonu:</div>
              <div class="price">
                {{ formatPrice(pg.price.totalFundAmount) }} TL
              </div>
            </div>
            <div class="description">
              <div>Komisyon:</div>
              <div class="price">
                {{ formatPrice(pg.price.totalCommissionAmount) }} TL
              </div>
            </div>
          </div>
          <div class="package-item__price" :class="!pg.isEnabled ? 'h100' : ''">
            <div class="buy" v-if="pg.isEnabled">
              <base-button @click="purchase(pg.id, pg)">Talep Et</base-button>
            </div>
            <div class="buy" v-else>
              <div class="tag tooltip">
                <div class="tooltiptext">
                  <div class="texts">
                    <span class="text" v-if="!pg.isResearch">
                      Yükseltme işlemleri yalnızca "Paket Talep Et" üzerinden
                      yapılabilir.
                    </span>
                    <span class="text" v-else> Bu pakete sahipsiniz. </span>
                  </div>

                  <div class="triangle-down"></div>
                </div>
                <span class="text">
                  Talep Et
                  <base-icon name="warn-yellow" class="icon"></base-icon>
                </span>
              </div>
            </div>
          </div>
          <div class="package-item__detail">
            <div class="wrap" :class="{ isToggled: pg.isOpened }">
              <div
                class="accordion-opener"
                :class="{ isToggled: pg.isOpened }"
                @click="toggleThisAccordion(index)"
              >
                <span v-if="pg.isOpened"> Özet Göster </span>
                <span v-else> Detay Göster </span>
                <base-icon class="svg" :name="'chevron-up'" />
              </div>
              <div class="price" v-if="pg.price.prices.length > 0">
                <ul>
                  <li v-for="(item, index) in pg.price.prices" :key="index">
                    <span class="has-price" v-if="item.totalPrice">
                      {{ formatPrice(item.totalPrice) }}
                      <span
                        class="has-price"
                        v-if="
                          item.totalPrice != 0 && item.info && item.info == '₺'
                        "
                      >
                        TL
                        <span v-if="index != pg.price.prices.length - 1"
                          >&nbsp;+&nbsp;</span
                        >
                      </span>
                      <span class="has-price" v-if="item.info == '€'">
                        EUR
                        <span v-if="index != pg.price.prices.length - 1"
                          >&nbsp;+&nbsp;</span
                        >
                      </span>
                      <span class="has-price" v-if="item.info == '$'">
                        USD
                        <span v-if="index != pg.price.prices.length - 1"
                          >&nbsp;+&nbsp;</span
                        >
                      </span>
                    </span>
                    <span v-else class="free">Ücretsiz</span>
                  </li>
                </ul>
              </div>
            </div>

            <div class="accordion-content" :class="{ isToggled: pg.isOpened }">
              <div class="package-item__image">
                <div class="image"></div>
              </div>
              <div class="package-item__info">
                <ul v-for="item in pg.package" :key="item.id" class="features">
                  <li v-if="item.marketFeature">
                    <span v-if="item.marketFeature && item.perspectiveFeature">
                      {{
                        item.perspectiveFeature.name != "Canlı Piyasa"
                          ? item.marketFeature.name
                          : ""
                      }}
                      {{
                        item.perspectiveFeature.name != "Prime"
                          ? item.perspectiveFeature.name
                          : ""
                      }}:<span class="inline">
                        {{
                          calculateTotal(
                            item.marketFeature.price,
                            item.perspectiveFeature.price
                          )
                        }}
                        TL</span
                      >
                    </span>
                    <span
                      v-if="
                        item.vendorFeature && item.vendorFeature.name != 'Yok'
                      "
                    >
                      <span class="inline"
                        >{{ item.marketFeature.name }}
                        {{ item.vendorFeature.name }} :</span
                      >
                      <span class="inline"
                        >{{ item.vendorFeature.price }} TL</span
                      >
                    </span>
                  </li>
                </ul>
                <ul
                  v-for="item in pg.foreignIndice"
                  :key="item.id"
                  class="features"
                >
                  <li v-if="item.foreignIndiceFeature">
                    <span v-if="item.foreignIndiceFeature">
                      {{ item.foreignIndiceFeature.name }}&nbsp;:
                      <span class="inline"
                        >{{ item.foreignIndiceFeature.price }}
                        <span
                          v-if="item.foreignIndiceFeature.priceInfo == '€'"
                          class="inline"
                          >EUR</span
                        ><span
                          v-if="item.foreignIndiceFeature.priceInfo == '₺'"
                          class="inline"
                          >TL</span
                        ><span
                          v-if="item.foreignIndiceFeature.priceInfo == '$'"
                          class="inline"
                          >USD</span
                        ></span
                      >
                    </span>
                  </li>
                </ul>
                <ul v-for="item in pg.research" :key="item.id" class="features">
                  <li v-if="item.researchFeature">
                    <span v-if="item.researchFeature">
                      {{ item.researchFeature.name }}&nbsp;:
                      <span class="inline"
                        >{{ item.researchFeature.price }}
                        <span
                          v-if="item.researchFeature.priceInfo == '€'"
                          class="inline"
                          >EUR</span
                        ><span
                          v-if="item.researchFeature.priceInfo == '₺'"
                          class="inline"
                          >TL</span
                        ><span
                          v-if="item.researchFeature.priceInfo == '$'"
                          class="inline"
                          >USD</span
                        >
                      </span>
                    </span>
                  </li>
                </ul>
                <ul
                  v-for="item in pg.algorithm"
                  :key="item.id"
                  class="features"
                >
                  <li v-if="item.algorithmFeature">
                    <span v-if="item.algorithmFeature">
                      {{ item.algorithmFeature.name }}&nbsp;:
                      <span class="inline"
                        >{{ item.algorithmFeature.price }}
                        <span
                          v-if="item.algorithmFeature.priceInfo == '€'"
                          class="inline"
                          >EUR</span
                        ><span
                          v-if="item.algorithmFeature.priceInfo == '₺'"
                          class="inline"
                          >TL</span
                        ><span
                          v-if="item.algorithmFeature.priceInfo == '$'"
                          class="inline"
                          >USD</span
                        >
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
              <div class="package-item__price"></div>
            </div>
          </div>
        </div>
      </slide>
    </carousel>
    <popup-right
      title="Seçilen en çok kullanılan paketin tüm lisansları"
      :isPopupVisible="isPopupVisible"
      @close="setDefaultValues"
    >
      <div class="package-settings">
        <div class="package-settings__top m-flex m-items-center">
          <div class="package-settings__image">
            <img
              v-if="selectedMoreElem.applicationFeature"
              alt="product image"
              :src="selectedMoreElem.applicationFeature.imageUrl"
            />
            <base-icon v-else name="no-image" />
          </div>
          <div class="package-settings__info">
            <h3 v-if="selectedMoreElem.applicationFeature">
              {{ selectedMoreElem.applicationFeature.name }}
            </h3>
            <p class="package-settings__info-platform"></p>
          </div>
        </div>

        <div class="package-settings__lisans">
          <div class="package-settings__lisans__information">
            <h5 id="lisans">Lisans Bilgileri</h5>
            <div class="market-table">
              <ul>
                <li>
                  <span v-if="selectedMoreElem.perspectiveFeature">
                    {{ selectedMoreElem.perspectiveFeature.name }}&nbsp;:
                    <span class="inline"
                      >{{ selectedMoreElem.perspectiveFeature.cost }} TL</span
                    >
                  </span>
                  <span v-if="selectedMoreElem.vendorFeature">
                    <span class="inline"
                      >{{ selectedMoreElem.vendorFeature.name }} :</span
                    >
                    <span class="inline"
                      >{{ selectedMoreElem.vendorFeature.cost }} TL</span
                    >
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </popup-right>
    <modal
      height="auto"
      class="cancel-modal"
      :adaptive="true"
      :key="pg.id"
      v-for="(pg, index) in packagesList"
      :index="index"
      :name="String(pg.id)"
    >
      <div class="modal-heading">
        <div class="modal-title">
          <h5>Paketi Talep Etmek İstiyor musunuz?</h5>
        </div>
        <a @click="closeModal(pg.id)">
          <base-icon class="close" name="close-circle" />
        </a>
      </div>
      <div class="modal-body">
        <div class="modal-body__top">
          <div class="modal-body__image">
            <img
              v-if="pg && pg.imageUrl"
              alt="product image"
              :src="pg.imageUrl"
              class="image"
            />
            <base-icon v-else name="no-image" class="image" />
          </div>
          <div class="modal-body__info">
            <h3 v-if="pg.application != null">
              {{ pg.application.name }}
              <span
                class="lighter"
                v-if="
                  pg.productName == 'Matriks' ||
                  pg.productName == 'Matriks IQ' ||
                  pg.productName == 'İdeal' ||
                  pg.productName == 'Foreks'
                "
              >
                {{ pg.platform.name }}
              </span>
              <span v-else>
                {{ pg.productName }}
              </span>
            </h3>
            <h3 class="title" v-else>
              {{ pg.productName }}
              <span class="lighter">
                ({{ pg.research[0].dateSelection.value }})
              </span>
            </h3>
            <div class="modal-body__info_bes">
              <span class="m-text-grayscale-80">BES / Yatırım Fonu:</span>
              {{ formatPrice(pg.price.totalFundAmount) }} TL
              <span class="m-text-grayscale-80">veya Komisyon:</span>
              {{ formatPrice(pg.price.totalCommissionAmount) }} TL
            </div>
            <div class="modal-body__info_price">
              <ul>
                <li v-for="(item, index) in pg.price.prices" :key="index">
                  <span v-if="item.totalPrice">
                    Paket Tutarı:
                    <span class="has-price">{{
                      formatPrice(item.totalPrice)
                    }}</span>
                    <span
                      class="has-price"
                      v-if="
                        item.totalPrice != 0 && item.info && item.info == '₺'
                      "
                    >
                      TL
                      <span v-if="index != pg.price.prices.length - 1"
                        >&nbsp;+&nbsp;</span
                      >
                    </span>
                    <span class="has-price" v-if="item.info == '€'">
                      EUR
                      <span v-if="index != pg.price.prices.length - 1"
                        >&nbsp;+&nbsp;</span
                      >
                    </span>
                    <span class="has-price" v-if="item.info == '$'">
                      USD
                      <span v-if="index != pg.price.prices.length - 1"
                        >&nbsp;+&nbsp;</span
                      >
                    </span>
                  </span>
                  <span v-else class="free">Ücretsiz</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-bottom">
        <base-button @click="closeModal(pg.id)" class="base-button red"
          >Vazgeç</base-button
        >
        <base-button @click="purchaseResearch(pg.id)" class="base-button"
          >Evet</base-button
        >
      </div>
    </modal>
  </div>
</template>

<style lang="scss" scoped>
.osm-vd {
  .cancel-modal {
    z-index: 9999;
    .infoArea {
      position: relative;
      bottom: initial;
    }
    .modal-heading {
      height: 40px;
      border-bottom: 1px solid var(--grayscale-30);
      display: flex;
      align-items: center;
      padding: 15px 30px;
      justify-content: space-between;
      .close {
        margin: 5px;
        cursor: pointer;
      }
    }
    .modal-bottom {
      margin-top: 1em;
      border-top: 1px solid var(--grayscale-30);
      display: flex;
      justify-content: space-between;
      padding: 15px 30px;
      .base-button {
        color: var(--grayscale-0);
        max-width: 180px;
        font-size: 15px;
        &.red {
          background-color: var(--color-warning);
        }
        @media (max-width: 375px) {
          max-width: 150px;
        }
      }
    }
    .modal-body {
      padding: 15px 30px;
      &__top {
        display: flex;
        align-items: center;
      }
      &__image {
        .image {
          margin-right: 30px;
          width: 96px;
          height: 140px;
          -o-object-fit: contain;
          object-fit: contain;
        }
      }
      &__info {
        .title {
          font-size: 20px;
          span {
            font-weight: normal;
            color: var(--grayscale-120);
            display: block;
            font-size: 16px;
          }
        }
        &-platform {
          margin: 5px 0;
          font-size: 16px;
        }
        &_price {
          color: var(--grayscale-120);
          font-size: 14px;
          font-weight: normal;
          margin-top: 5px;
          li {
            list-style-type: none;
            .has-price {
              color: #000;
            }
          }
        }
        &_bes {
          font-size: 14px;
          font-weight: normal;
          margin-top: 20px;
        }
      }
    }
  }
}
.package-slider {
  padding: 20px;
  background: var(--grayscale-0);
  overflow: hidden;
  @media (max-width: 768px) {
    padding: 20px 12px;
  }
  &__title {
    font-size: 14px;
    font-weight: 400;
    margin-right: 20px;
    color: var(--grayscale-190);
    @media (max-width: 475px) {
      font-size: 13px;
      margin-right: 0px;
    }
  }

  &__head {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
  }

  &__close {
    display: flex;
    align-items: center;
    background: transparent;
    width: max-content;
    color: var(--grayscale-90);

    svg {
      margin-left: 5px;
    }
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 43.54px;
    height: 24px;

    &-slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      -webkit-transition: 0.4s;
      transition: 0.4s;
      border-radius: 34px;

      &:before {
        position: absolute;
        content: "";
        height: 18px;
        width: 18px;
        left: 5px;
        bottom: 3px;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
        border-radius: 50%;
      }
      input {
        opacity: 0;
        width: 0;
        height: 0;
      }
    }

    input:checked + .switch-slider {
      background-color: var(--color-primary-default);
    }

    input:checked + .switch-slider:before {
      -webkit-transform: translateX(16px);
      transform: translateX(16px);
    }
  }

  ::v-deep .VueCarousel {
    height: min-content;
  }
}

.package-item {
  position: relative;
  background: var(--grayscale-0);
  border-radius: var(--radius-first);
  border: 1px solid var(--color-primary-tint-second);
  margin-right: 10px;
  display: flex;
  align-items: flex-start;
  padding: 12px;
  box-sizing: border-box;
  flex-wrap: wrap;
  @media (max-width: 515px) {
    width: 100%;
    flex-direction: column;
    min-height: 320px;
    padding: 12px 6px;
  }

  &__image {
    flex: 0.1;
    .image {
      width: 80px;
    }
    @media (max-width: 515px) {
      flex: 1;
      width: 100%;
      text-align: center;
      margin-top: 15px;
    }
  }

  &__price {
    flex: 0.4;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex-direction: column;
    gap: 5px;
    text-align: right;

    @media (max-width: 515px) {
      min-height: auto;
      width: 100%;
      flex: 1;
      order: 3;
      .base-button {
        max-width: 100% !important;
      }
    }

    .price {
      li {
        display: inline-block;
        color: var(--color-primary-default);
        font-weight: bold;
        list-style: none;
        font-size: 12px;
        .has-price {
          background: transparent;
          border-radius: var(--radius-five);
          color: var(--color-primary-black-metallic);
        }
        span {
          background: var(--grayscale-140);
        }
      }
    }
    .features {
      text-align: right;
      li {
        list-style-type: none;
        font-size: 10px;
        line-height: 18px;
        color: var(--grayscale-130);
        span {
          background: transparent;
          display: block;
          .inline {
            display: inline-block;
            min-width: 32px;
          }
        }
      }
      .more {
        font-size: 10px;
        line-height: 18px;
        cursor: pointer;
        width: 120px;
        padding: 0px;
        text-align: center;
        justify-content: center;
        display: flex;
        align-items: center;
        color: var(--grayscale-0);
        background: var(--color-primary-active);
        margin-right: 0px;
        margin-left: auto;
        transform: scale(1);
        transition: ease-in-out 0.2s;
        border-radius: 4px;
        &:hover {
          transform: scale(0.94);
        }
      }
    }
    .buy {
      width: 100%;
      .base-button {
        background: var(--color-primary-active);
        height: 32px;
        font-size: 12px;
        max-width: 120px;
      }
    }
    &.h100 {
      .buy {
        height: 100%;
        display: flex;
        justify-content: flex-end;
      }
      .tag.tooltip {
        margin-right: 0px;
        min-width: 120px;
        height: 32px;
        border-radius: 0px;
        padding: 0px;
        @media (max-width: 768px) {
          width: 100%;
        }
      }
    }
    .tag {
      background: var(--color-primary-warning-text-background);
      padding: 4px 5px;
      margin-right: 10px;
      border-radius: var(--radius-third);
      display: flex;
      align-items: center;
      text-align: center;
      @media (max-width: 941px) {
        margin-bottom: 5px;
        padding: 2px 8px;
      }
      .text {
        font-size: 12px;
        text-overflow: ellipsis;
        display: flex;
        align-items: center;
        color: var(--color-primary-warning-text);
        justify-content: center;
        height: 100%;
        @media (max-width: 400px) {
          font-size: 10px !important;
        }
        .icon {
          width: 42px;
          margin-right: -17px;
        }
      }
      .tooltiptext {
        min-width: 210px;
        bottom: -130%;
        right: 0px;
        left: auto;
        @media (max-width: 768px) {
          min-width: 150px;
          bottom: 100%;
          left: 0px;
          right: 0px;
          transform: translateX(0px);
        }
        .triangle-down {
          width: 0;
          height: 0;
          border-left: 8px solid #7ea7a3;
          border-bottom: 8px solid transparent;
          border-top: 8px solid transparent;
          position: absolute;
          bottom: 67%;
          left: auto;
          right: -17px;
          margin: 0 auto;
          @media (max-width: 768px) {
            bottom: -47%;
            border-top: 8px solid #7ea7a3;
            border-bottom: 8px solid transparent;
            border-right: 8px solid transparent;
            border-left: 8px solid transparent;
            right: 50%;
          }
        }
      }
    }
  }

  &__info {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0px 12px;

    @media (max-width: 515px) {
      text-align: center;
      box-sizing: border-box;
      padding: 0px;
      flex: 1;
      order: 1;
    }

    .title {
      h6 {
        line-height: normal;
        font-size: 14px;
        font-weight: bold !important;
        margin-bottom: 4px;
        span {
          font-weight: normal;
          color: var(--grayscale-120);
          display: block;
          min-height: 21px;
        }
      }
    }

    .description {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-bottom: 4px;

      .price {
        font-weight: 600;
      }
    }
  }

  &__detail {
    display: flex;
    flex-basis: 100%;
    flex-wrap: wrap;
    width: 100%;
    @media (max-width: 515px) {
      order: 2;
      .price {
        position: absolute;
        top: 0px;
        right: 10px;
      }
    }
    .wrap {
      display: flex;
      justify-content: space-around;
      flex-basis: 100%;
      &.isToggled {
        border-bottom: 1px solid var(--grayscale-210);
        padding-bottom: 12px;
        margin-bottom: 12px;
      }
      .price {
        min-width: max-content;
        li {
          display: inline-block;
          font-weight: bold;
          list-style: none;
          font-size: 12px;
          .free {
            border-radius: 5px;
            color: var(--color-primary-default);
            border: 0px solid var(--color-primary-default);
            background: var(--grayscale-140);
            padding: 2px 20px;
          }
        }
      }
    }
    .accordion-opener {
      display: flex;
      align-items: center;
      color: var(--color-primary-black-metallic);
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px;
      cursor: pointer;
      flex-basis: 100%;

      @media (max-width: 515px) {
        justify-content: center;
        margin-top: 13px;
        margin-bottom: 21px;
        &.isToggled {
          margin-bottom: 0px;
        }
      }
      .svg {
        transform: rotate(180deg) scale(0.7);
        fill: var(--color-primary-black-metallic);
      }
      &.isToggled {
        .svg {
          transform: rotate(0deg) scale(0.7);
        }
      }
    }
    .accordion-content {
      flex-wrap: wrap;
      display: none;
      @media (max-width: 515px) {
        .package-item__image,
        .package-item__price {
          display: none;
        }
      }
      span:not(.inline) {
        display: flex;
        justify-content: space-between;
        width: 100%;
      }
      &.isToggled {
        display: flex;
        width: 100%;
      }

      .features {
        display: block;
        width: 100%;
        margin-bottom: 12px;
        &:last-child {
          @media (min-width: 768px) {
            margin-bottom: 0px;
          }
        }
        li {
          display: flex;
          justify-content: space-between;
          font-size: 12px;
          color: var(--grayscale-130);
          margin-bottom: 12px;
          &:last-child {
            margin-bottom: 0px;
          }
          flex-direction: column;
        }
      }
    }
  }
}

.open-arrow {
  -moz-transform: rotate(-180deg);
  -ms-transform: rotate(-180deg);
  -webkit-transform: rotate(-180deg);
  transform: rotate(-180deg);
  transition: transform 0.5s;
}

.close-arrow {
  transition: transform 0.5s;
}
</style>

<style lang="scss">
.VueCarousel {
  padding-top: 20px;
}
.VueCarousel-wrapper {
  padding-bottom: 10px;
}
.VueCarousel-dot-container {
  margin-top: 0 !important;
}
.VueCarousel-dot {
  margin-top: 10px !important;
  padding: 5px !important;

  &:focus {
    outline: none !important;
  }
}

.package-settings {
  overflow: auto;
  @media (min-width: 640px) {
    height: calc(100vh - 250px);
  }

  &__info {
    h3 {
      font-size: 16px;
      font-weight: 600;
    }
    span {
      font-size: 14px;
    }
  }
  &__info-platform {
    font-size: 16px;
  }
  &__info_price {
    font-size: 29px;
    font-weight: bold;
    margin-top: 12px;
  }
  &__info_bes,
  &__info_bes span {
    font-size: 14px;
  }
  &__image img {
    margin-right: 20px;
    width: 80px;
    object-fit: contain;
  }
  &__top {
    margin-bottom: 30px;
  }
  &__lisans {
    overflow-y: auto;
    &__information {
      padding: 20px;
      background: var(--grayscale-0);
      margin-bottom: 20px;
      @media (max-width: 768px) {
        border-radius: 4px;
        padding: 12px;
      }

      h5 {
        font-size: 14px;
        font-weight: 600;
        @media (max-width: 768px) {
          border-bottom: 1px solid var(--color-primary-tint-second);
          margin: auto -12px 16px -12px;
          padding: 0px 12px 13px 12px;
        }
      }
      .table {
        margin-bottom: 0px !important;
      }
    }
    @media (max-width: 898px) {
      overflow: auto;
    }
    .table {
      border-collapse: collapse;
      text-indent: 0;
      min-width: 100%;
      border-radius: var(--radius-second) !important;
      overflow: auto;
      border: solid 1px var(--color-primary-tint-second);
      background-color: #fff;
      margin: 20px 0px;
      overflow-y: visible !important;

      ::v-deep th {
        background: var(--grayscale-160);
        height: 40px;
        font-weight: 600 !important;
      }

      ::v-deep th,
      ::v-deep td {
        font-size: 12px;
        vertical-align: middle;
        border-top: 1px solid #e8e8e8;
        border-bottom: 1px solid #e8e8e8;
        font-weight: 500 !important;

        .option {
          .veri-dagitim-selectbox.v-select {
            border: 1px solid transparent;
            width: 100%;

            .vs {
              &__dropdown-toggle {
                padding: 0px;
                border: 0px !important;
                position: relative;

                &:focus-visible {
                  outline: none !important;
                }

                svg {
                  display: block !important;
                }
              }

              &__selected {
                padding: 0;
                margin: 0;

                &-options {
                  padding: 0px !important;
                  position: relative;
                }
              }

              &__clear {
                display: none !important;
              }

              &__actions {
                padding: 0px;
                cursor: pointer !important;
                background: transparent !important;
              }
            }

            &__search,
            &__search:focus {
              border: none !important;
            }
          }

          .editing-view-port {
            display: none !important;
          }
        }
      }
      ::v-deep tbody {
        tr:nth-child(2n) {
          background: var(--color-primary-zebra);
        }
        tr td {
          height: 26px;
          color: var(--grayscale-200);

          &:nth-child(2) {
            width: 110px;
            padding: 18px 0px;
            .paranthesis {
              font-size: 11px;
            }
          }

          &:nth-child(3),
          &:nth-child(4) {
            min-width: 252px;
          }
        }
        tr td:first-child {
          width: 38px;
          padding: 0px;
          padding-right: 6px;
          text-align: right;
          border-left: 1px solid #e8e8e8;
        }

        td:last-child {
          width: 150px;
          padding-right: 20px;
          .veri-dagitim-selectbox.v-select {
            .vs__dropdown-toggle {
              min-width: auto;
              font-size: 14px;
            }
            .vs__search {
              display: none;
            }
          }
        }
      }
    }
    ::v-deep .setHeight tbody tr td {
      height: 64px !important;
    }

    .info-option {
      display: flex;
      align-items: center;
      justify-content: left;
      svg {
        cursor: pointer;
      }
    }
    .accordion-container {
      width: 100%;
    }
  }
  @media (max-width: 640px) {
    &__bottom-right {
      text-align: center;
    }
  }
  &__bottom {
    width: 100%;
    padding: 20px 0px 8px 0px;
    border-top: 1px solid var(--grayscale-30);
    justify-content: space-between;
    background-color: var(--grayscale-10);

    &-left {
      display: flex;
    }
    @media (max-width: 640px) {
      position: relative;
      flex-flow: column;
    }
    ::v-deep .form-group {
      position: relative;
      margin-right: 16px;
      width: 100%;
    }
    ::v-deep .form-control-label {
      font-size: 12px;
      color: var(--grayscale-70);
      position: absolute;
      padding: 0 7px;
      margin-left: 10px;
      z-index: 2;
      top: -5px;
    }
  }
  &__bottom-right {
    line-height: 24px;
    @media (max-width: 640px) {
      text-align: left;
      margin-bottom: 0px;
      width: 100%;
    }
    ::v-deep p,
    ::v-deep span {
      font-size: 14px;
      font-weight: 600;
      color: var(--grayscale-120);
    }
    ::v-deep p {
      color: var(--color-primary-black-metallic);
    }
  }
  @media (max-width: 640px) {
    &__bottom-left {
      width: 100%;
      flex-direction: column;
    }
  }

  &__bottom-action {
    width: 216px;
    margin-left: 40px;
    @media (max-width: 640px) {
      width: 100%;
      align-items: inherit;
      flex-flow: column;
      margin-left: auto;
      .start-date-select {
        width: 100%;
        margin-bottom: 10px;
      }
    }
  }
  &__price {
    align-items: center;
    justify-content: center;
    font-weight: 600;
    @media (max-width: 640px) {
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 15px;
    }
    span {
      font-size: 14px;
      color: var(--grayscale-120);
    }
    h2 {
      font-size: 14px;
      color: var(--color-primary-black-metallic);
      margin-left: 5px;
    }
  }
  .up svg {
    color: #28a745;
  }
  .down svg {
    color: #dc3545;
  }
  .warning-area {
    margin-bottom: 2em;
    .row-area {
      border: 1px solid var(--grayscale-30);
      border-radius: var(--radius-second);
      margin-top: 1em;
      .row {
        padding: 15px;
        display: flex;
        align-items: center;
        .icon-area {
          margin-right: 10px;
        }
        &:nth-child(odd) {
          background-color: var(--grayscale-0);
        }
      }
    }
  }
  .terminal-area {
    padding: 20px 0;
    margin-bottom: 1em;
    .text {
      margin-bottom: 1em;
    }
  }
}
</style>
